/******************************************** STYLING *********************************************/
const s = require('./x-close-button.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';
import {isNumber, omit} from 'mad-utils/lib/react';
import {onSubmitKeyPress} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
export type XCloseButtonProps = {
    onClick: EventHandler;
    size?: number;
    topRightPos?: number;
    id?: string;
    className?: string;
    styleInner?: React.CSSProperties;
    styleOuter?: React.CSSProperties;
};

/********************************************* EXPORT *********************************************/
/**
 * "X" close button
 * Typically on top-right of a modal
 *
 * @param {Function} onClick Event handler for X click
 * @param {number} size Width & height of X button
 * @param {string} className CSS class overrides
 * @param {CSSProperties} style Style overrides
 */
export const XCloseButton = React.forwardRef((props: XCloseButtonProps, ref?: any) => {
    const {onClick, size, id, styleInner, styleOuter, className} = props;
    return (
        <div className={cn(s[`x-close-button-wrapper`])} style={styleOuter}>
            <span
                className={cn(s[`x-close-button`], className)}
                style={
                    isNumber(size)
                        ? {
                              width: size,
                              height: size,
                              ...omit(styleInner, ['width', 'height']),
                          }
                        : styleInner
                }
                onClick={onClick}
                onKeyUp={onSubmitKeyPress(onClick)}
                tabIndex={0}
                ref={ref}
                id={id || null}
            />
        </div>
    );
});

XCloseButton.displayName = `XCloseButton`;
